import { createLoadingReducer } from './utils';

export default createLoadingReducer('ACCESSY_SETTINGS');
